<template>
  <el-dialog
    title="选择测风塔"
    :visible.sync="dialogVisible"
    :modal="false"
    :before-close="handleClose"
    width="350px"
    v-drag
  >
    <div class="dialog-content">
      <el-input
        v-model="searchViceParam"
        @input="filter"
        placeholder="关键字,逗号分隔"
        class="search_input"
      >
        <i slot="suffix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <div class="tree-div">
        <el-tree
          :data="data"
          node-key="id"
          :check-on-click-node="true"
          @check-change="handleClick"
          show-checkbox
          :check-strictly="true"
          :filter-node-method="filterNode"
          ref="viceTowerTree"
          :default-expanded-keys="defaultTowerIdArr"
          :default-checked-keys="defaultVersionIdArr"
          :props="defaultProps"
        ></el-tree>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <ct-button size="small" :btn-click="closeModal" style="margin-right:10px"
        >取消</ct-button
      >
      <ct-button size="small" type="primary" :btn-click="confirm"
        >确定</ct-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { getToken } from '@/utils/index';
import { getDataURLByEchartOptions } from '@/utils';
import loadingMask from '@/components/loading-mask';
import moment from 'moment';
export default {
  props: ['visible', 'treeData'],
  data() {
    return {
      searchViceParam: '',
      dialogVisible: false,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      data: [],
      defaultTowerIdArr: [],
      defaultVersionIdArr: [],
      viceTowerId: [],
      viceTowerVersionId: []
    };
  },
  created() {
    this.dialogVisible = this.visible;
    this.data = this.dealData();
    this.getDefaultExpand();
  },
  computed: {
    towerInfo() {
      return this.$store.state.WindData.towerObj;
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
    },
    dialogVisible: {
      handler(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  methods: {
    handleClick() {},

    filter() {
      let dataTree = this.dealData();
      if (this.searchViceParam) {
        this.expandAllNode = true;
        let paramArr = this.searchViceParam.split(',');
        let regStr = paramArr[0];
        let regObj = new RegExp(regStr);
        let treeData = dataTree.filter(function(item) {
          let a = item.label.search(regObj);
          return a != -1 ? true : false;
        });
        this.data = [...treeData];
      } else {
        this.data = dataTree;
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    getDefaultExpand() {
      let { towerId, versionId } = this.towerInfo || {};
      this.defaultTowerIdArr.push(towerId);
      this.defaultVersionIdArr.push(versionId);
      this.viceTowerId = [towerId];
      this.viceTowerVersionId = [versionId];
    },
    //转化为tree的数据格式
    dealData() {
      let arr = [];
      this.treeData.forEach(item => {
        let { towerId, towerVersionList = [], towerCode } = item;
        let treeNode = {
          id: towerId,
          towerId: towerId,
          label: towerCode
        };
        let treeChildNode = [];
        towerVersionList.forEach(child => {
          let { versionId, versionName } = child;
          treeChildNode.push({
            id: versionId,
            towerId: towerId,
            versionId: versionId,
            label: versionName
          });
        });
        treeNode.children = treeChildNode;
        arr.push(treeNode);
      });
      return arr;
    },
    async confirm() {
      this.viceTowerId = [];
      this.viceTowerVersionId = [];
      let { towerId, versionId } = this.towerInfo || {};
      let selectNodes = this.$refs.viceTowerTree.getCheckedNodes();
      for (let i = 0; i < selectNodes.length; i++) {
        if (!selectNodes[i].versionId) {
          continue;
        } else {
          this.viceTowerId.push(selectNodes[i].towerId);
          this.viceTowerVersionId.push(selectNodes[i].versionId);
        }
      }
      if (this.viceTowerVersionId.length == 0) {
        return this.$message.error('请选择测风数据版本！');
      } else {
        this.showViceTowerDialog = false;
        this.viceTowerId.unshift(towerId);
        this.viceTowerVersionId.unshift(versionId);

        this.viceTowerId = Array.from(new Set(this.viceTowerId.map(Number)));
        //console.log(this.viceTowerId);
        this.viceTowerVersionId = Array.from(
          new Set(this.viceTowerVersionId.map(Number))
        );

        let res = await this.doGetExportParam();
        console.log({ res });
      }
    },
    async doGetExportParam() {
      this.aswitch = loadingMask({ mask: true });
      //准备导出
      let key = getToken();
      let towerIds = this.viceTowerId.toString();
      let versions = this.viceTowerVersionId.toString();
      this.params = {
        apiKey: key,
        towerIds: towerIds,
        versions: versions
      };
      //1.风切变
      let res = await this.$fetch('/winddata/tower/report/getWindShearData', {
        module: 'windData',
        params: {
          towerIds: towerIds,
          versions: versions
        }
      });
      for (let i = 0; i < res.data.WindShearList.length; i++) {
        let WindShearData = res.data.WindShearList[i];
        let avgSpeedList = WindShearData.avgSpeedList;
        let shearData = WindShearData.exp;
        let towerID = WindShearData.towerID;
        let versionId = this.viceTowerVersionId[
          this.viceTowerId.map(Number).indexOf(towerID)
        ];
        let option = {
          title: {
            text: '风切变',
            textStyle: {
              color: '#000000',
              fontFamily: 'FangSong'
            },
            left: 'center'
          },
          xAxis: {
            name: '风速(m/s)',
            type: 'value',
            nameTextStyle: {
              padding: [8, 8, 8, 8]
            },
            axisLine: {
              lineStyle: {
                color: '#000000'
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            }
          },
          yAxis: {
            name: '高度(m)',
            nameLocation: 'end',
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#000000'
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            }
          },
          tooltip: {
            trigger: 'axis'
          },
          backgroundColor: 'transparent',
          series: [
            {
              type: 'scatter',
              data: avgSpeedList
            },
            {
              type: 'line',
              smooth: true,
              data: shearData,
              symbol: 'none',
              lineStyle: {
                color: '#0099bb'
              }
            }
          ]
        };
        getDataURLByEchartOptions(option).then(res => {
          this.params['windSheraChart_' + versionId] = res;
        });
        if (i == res.data.WindShearList.length - 1) {
          this.doExportReport();
        }
      }
      //2.测风塔逐月风速图
      let res2 = await this.$fetch('/winddata/tower/report/getSpeedMonthData', {
        module: 'windData',
        params: {
          towerIds: towerIds,
          versions: versions
        }
      });
      for (let i = 0; i < res2.data.resList.length; i++) {
        let monthData = res2.data.resList[i];
        let speedSeriesData = [];
        let speedLegendData = [];
        let towerID = monthData.towerID;
        let versionId = this.viceTowerVersionId[
          this.viceTowerId.map(Number).indexOf(towerID)
        ];
        for (let j = 0; j < monthData.monthSpeedList.length; j++) {
          let legendName = monthData.monthSpeedList[j].channelName;
          speedLegendData.push(legendName);
          speedSeriesData.push({
            name: legendName,
            type: 'line',
            data: monthData.monthSpeedList[j].data,
            symbol: 'circle',
            symbolSize: 2,
            lineStyle: {
              //color:"#000"
            }
          });
        }
        let option = {
          title: {
            text: '风速月变化',
            left: 'center',
            textStyle: {
              color: '#000000',
              fontFamily: 'FangSong'
            }
          },
          legend: {
            data: speedLegendData,
            textStyle: {
              color: '#000000'
            },
            orient: 'vertical',
            y: 'center',
            x: 'right',
            align: 'left'
          },
          grid: {
            x: '30',
            right: '100'
          },
          tooltip: {
            trigger: 'axis'
          },
          backgroundColor: 'transparent',
          xAxis: {
            name: '时间(月)',
            type: 'category',
            data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            axisLine: {
              lineStyle: {
                color: '#000'
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            }
          },
          yAxis: {
            name: '风速(m/s)',
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#000'
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            }
          },
          series: speedSeriesData
        };

        getDataURLByEchartOptions(option, { notMerge: true }).then(res => {
          this.params['speedMmonthChart_' + versionId] = res;
        });
        if (i == res2.data.resList.length - 1) {
          this.doExportReport();
        }
      }
      //6.风能玫瑰图
      let res6 = await this.$fetch('/winddata/tower/report/getwindPowerData', {
        module: 'windData',
        params: {
          towerIds: towerIds,
          versions: versions
        }
      });
      for (let i = 0; i < res6.data.resList.length; i++) {
        let resdata = res6.data.resList[i];
        let towerID = resdata.towerID;
        let versionId = this.viceTowerVersionId[
          this.viceTowerId.map(Number).indexOf(towerID)
        ];
        let windSymbol = [
          '0°',
          '22.5°',
          '45°',
          '67.5°',
          '90°',
          '112.5°',
          '135°',
          '157.5°',
          '180°',
          '202.5°',
          '225°',
          '247.5°',
          '270°',
          '292.5°',
          '315°',
          '337.5°'
        ];
        let windPowerArray = resdata.windPowerArray;
        let option = {
          title: {
            text: '风能玫瑰(%)',
            textStyle: {
              color: '#000000',
              fontFamily: 'FangSong'
            },
            left: 'center'
          },
          textStyle: {
            color: '#000'
          },
          tooltip: {
            trigger: 'item',
            formatter: '角度:{b0} <br /> 频率:{c0} %'
          },
          backgroundColor: 'transparent',
          angleAxis: {
            type: 'category',
            data: windSymbol,
            startAngle: -258.75,
            splitLine: {
              show: true,
              lineStyle: {
                color: ['#000000'],
                type: 'solid',
                opacity: 1
              }
            }
          },
          polar: {
            center: ['50%', '54%'],
            radius: '80%'
          },
          radiusAxis: {
            z: 100
          },
          series: [
            {
              type: 'bar',
              data: windPowerArray,
              coordinateSystem: 'polar'
            }
          ]
        };
        getDataURLByEchartOptions(option, {
          width: '350px',
          height: '300px'
        }).then(res => {
          this.params['windEnergyRose_' + versionId] = res;
        });
        if (i == res6.data.resList.length - 1) {
          this.doExportReport();
        }
      }
      //5.风向玫瑰
      let res5 = await this.$fetch('/winddata/tower/report/getSpeedRoseData', {
        module: 'windData',
        params: {
          towerIds: towerIds,
          versions: versions
        }
      });
      for (let i = 0; i < res5.data.resList.length; i++) {
        let resdata = res5.data.resList[i];
        let towerID = resdata.towerID;
        let versionId = this.viceTowerVersionId[
          this.viceTowerId.map(Number).indexOf(towerID)
        ];
        let windSymbol = [
          '0°',
          '22.5°',
          '45°',
          '67.5°',
          '90°',
          '112.5°',
          '135°',
          '157.5°',
          '180°',
          '202.5°',
          '225°',
          '247.5°',
          '270°',
          '292.5°',
          '315°',
          '337.5°'
        ];
        let windFrequency = resdata.wdfreq;
        let option = {
          title: {
            text: '风向玫瑰(%)',
            textStyle: {
              color: '#000000',
              fontFamily: 'FangSong'
            },
            left: 'center'
          },
          backgroundColor: 'transparent',
          textStyle: {
            color: '#000'
          },
          tooltip: {
            trigger: 'item',
            formatter: '角度:{b0} <br /> 频率:{c0} %'
          },
          angleAxis: {
            type: 'category',
            data: windSymbol,
            startAngle: -258.75,
            splitLine: {
              show: true,
              lineStyle: {
                color: ['#000000'],
                type: 'solid',
                opacity: 1
              }
            }
          },
          polar: {
            center: ['50%', '54%'],
            radius: '80%'
          },
          radiusAxis: {
            z: 100
          },
          series: [
            {
              type: 'bar',
              data: windFrequency,
              coordinateSystem: 'polar'
            }
          ]
        };
        getDataURLByEchartOptions(option, {
          width: '350px',
          height: '300px'
        }).then(res => {
          this.params['directionRose_' + versionId] = res;
        });
        if (i == res5.data.resList.length - 1) {
          this.doExportReport();
        }
      }
      //4.威布尔分布
      let res4 = await this.$fetch('/winddata/tower/report/getWeiBullData', {
        module: 'windData',
        params: {
          towerIds: towerIds,
          versions: versions
        }
      });
      for (let i = 0; i < res4.data.resList.length; i++) {
        let resdata = res4.data.resList[i];
        let towerID = resdata.towerID;
        let versionId = this.viceTowerVersionId[
          this.viceTowerId.map(Number).indexOf(towerID)
        ];
        let a = resdata.weibull_a;
        let k = resdata.weibull_k;
        this.params['weibullA_' + versionId] = a;
        this.params['weibullK_' + versionId] = k;
        let subtext = 'A: ' + a + '   K: ' + k;
        let weibullData = resdata.weibullData;
        let speedFrequencyList = resdata.windFrequency;
        let ESpeedFrequencyList = [...speedFrequencyList];
        ESpeedFrequencyList.pop();
        let option = {
          title: {
            text: '',
            subtext: subtext,
            right: '150',
            subtextStyle: {
              color: '#000000'
            }
          },
          xAxis: {
            name: '风速(m/s)',
            nameLocation: 'middle',
            type: 'category',
            nameTextStyle: {
              padding: [8, 8, 8, 8]
            },
            data: [
              1,
              2,
              3,
              4,
              5,
              6,
              7,
              8,
              9,
              10,
              11,
              12,
              13,
              14,
              15,
              16,
              17,
              18,
              19,
              20,
              21,
              22,
              23,
              24,
              25
            ],
            axisLine: {
              lineStyle: {
                color: '#000000'
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            }
          },
          yAxis: [
            {
              name: '频率(%)',
              nameLocation: 'end',
              type: 'value',
              axisLine: {
                lineStyle: {
                  color: '#000000'
                }
              },
              splitLine: {
                lineStyle: {
                  type: 'dashed'
                }
              }
            }
          ],
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            show: false
          },
          series: [
            {
              name: '风速频率',
              type: 'bar',
              color: '#63b8ff',
              yAxisIndex: 0,
              data: ESpeedFrequencyList
            },
            {
              name: '威布尔',
              type: 'line',
              smooth: true,
              color: '#ffd700',
              stack: 'a',
              data: weibullData
            }
          ]
        };
        getDataURLByEchartOptions(option).then(res => {
          this.params['weiBull_' + versionId] = res;
        });
        if (i == res4.data.resList.length - 1) {
          this.doExportReport();
        }
      }
      //7.20年平均风速
      let res7 = await this.$fetch('/winddata/tower/report/getMreeaSpeedData', {
        module: 'windData',
        params: {
          towerIds: towerIds,
          versions: versions
        }
      });
      for (let i = 0; i < res7.data.resList.length; i++) {
        let resdata = res7.data.resList[i];
        let towerID = resdata.towerID;
        let dataList = resdata.data;
        let barSeriesData = [...dataList];
        let representativeYearData = {
          value: barSeriesData.pop(),
          itemStyle: {
            color: '#ff0000'
          }
        };
        barSeriesData.push(representativeYearData);
        let versionId = this.viceTowerVersionId[
          this.viceTowerId.map(Number).indexOf(towerID)
        ];
        //获取x轴年份
        // let currentYear = new Date().getFullYear(); //当前年份
        let currentYear = 2017;
        let TweentyYearList = [];
        for (let j = currentYear; j > currentYear - 20; j--) {
          TweentyYearList.unshift(j);
        }
        TweentyYearList.push('代表年');

        //根据接口返回的数据，计算20年平均值
        let average = 0;
        let totalValue = 0;
        for (let k = 0; k < 20; k++) {
          totalValue += dataList[k];
        }
        average = (totalValue / 20).toFixed(2);

        //组成平均值的echart线的数据
        let lineSeriesData = [];
        for (let m = 0; m < TweentyYearList.length; m++) {
          lineSeriesData.push(average);
        }
        let option = {
          title: {
            text: '',
            right: '150',
            subtextStyle: {
              color: '#000000'
            }
          },
          xAxis: {
            name: '年份',
            type: 'category',
            nameTextStyle: {
              padding: [8, 8, 8, 8]
            },
            data: TweentyYearList,
            axisLine: {
              lineStyle: {
                color: '#000000'
              }
            },
            axisLabel: {
              fontSize: 5,
              rotate: 60
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            }
          },
          yAxis: [
            {
              name: '风速(m/s)',
              nameLocation: 'center',
              type: 'value',
              axisLine: {
                lineStyle: {
                  color: '#000000'
                }
              },
              splitLine: {
                lineStyle: {
                  type: 'dashed'
                }
              }
            }
          ],
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            show: true,
            bottom: 10,
            data: ['各年平均', '20年平均']
          },
          series: [
            {
              name: '各年平均',
              type: 'bar',
              barWidth: 10,
              color: '#63b8ff',
              yAxisIndex: 0,
              data: barSeriesData
            },
            {
              name: '20年平均',
              type: 'line',
              smooth: true,
              color: '#00ff00',
              stack: 'a',
              data: lineSeriesData,
              symbol: 'none'
            }
          ]
        };
        //console.log({ option });

        getDataURLByEchartOptions(option).then(res => {
          this.params['merraSpeedChart_' + versionId] = res;
        });
        if (i == res7.data.resList.length - 1) {
          this.doExportReport();
        }
      }

      //3.测风塔逐时风速图
      let res3 = await this.$fetch('/winddata/tower/report/getSpeedHourData', {
        module: 'windData',
        params: {
          towerIds: towerIds,
          versions: versions
        }
      });
      for (let i = 0; i < res3.data.resList.length; i++) {
        let monthData = res3.data.resList[i];
        let speedSeriesData = [];
        let speedLegendData = [];
        let towerID = monthData.towerID;
        let versionId = this.viceTowerVersionId[
          this.viceTowerId.map(Number).indexOf(towerID)
        ];
        for (let j = 0; j < monthData.monthSpeedList.length; j++) {
          let legendName = monthData.monthSpeedList[j].channelName;
          speedLegendData.push(legendName);
          speedSeriesData.push({
            name: legendName,
            type: 'line',
            data: monthData.monthSpeedList[j].data,
            symbol: 'circle',
            symbolSize: 2,
            lineStyle: {
              //color:"#000"
            }
          });
        }
        let option = {
          title: {
            text: '风速小时变化',
            left: 'center',
            textStyle: {
              color: '#000000',
              fontFamily: 'FangSong'
            }
          },
          legend: {
            data: speedLegendData,
            textStyle: {
              color: '#000000'
            },
            orient: 'vertical',
            y: 'center',
            x: 'right',
            align: 'left'
          },
          grid: {
            x: '30',
            right: '100'
          },
          tooltip: {
            trigger: 'axis'
          },
          backgroundColor: 'transparent',
          xAxis: {
            name: '时间(小时)',
            type: 'category',
            data: [
              1,
              2,
              3,
              4,
              5,
              6,
              7,
              8,
              9,
              10,
              11,
              12,
              13,
              14,
              15,
              16,
              17,
              18,
              19,
              20,
              21,
              22,
              23
            ],
            axisLine: {
              lineStyle: {
                color: '#000'
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            }
          },
          yAxis: {
            name: '风速(m/s)',
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#000'
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            }
          },
          series: speedSeriesData
        };
        getDataURLByEchartOptions(option, { notMerge: true }).then(res => {
          this.params['speedHourChart_' + versionId] = res;
          if (i == res3.data.resList.length - 1) {
            this.doExportReport();
          }
        });
      }
    },
    doExportReport() {
      let { versionId } = this.towerInfo || {};
      let Vid = versionId;
      let params = this.params;
      let hasAllParams =
        params['merraSpeedChart_' + Vid] &&
        params['speedHourChart_' + Vid] &&
        params['weiBull_' + Vid] &&
        params['directionRose_' + Vid] &&
        params['windEnergyRose_' + Vid] &&
        params['speedMmonthChart_' + Vid] &&
        params['windSheraChart_' + Vid];
      if (hasAllParams) {
        // let towerName = this.selectTowerCode;
        // let versionName = this.selectVersionName;
        {
          this.$postForm('/winddata/tower/report/downReport', {
            module: 'windData',
            showError: true,
            noJudge: true,
            responseType: 'blob',
            data: params
          })
            .then(res => {
              const blob = new Blob([res.data]);
              var link = document.createElement('a');
              var fileURL = URL.createObjectURL(blob);
              link.target = '_blank';
              link.href = fileURL;
              const time = moment().format('YYYY-MM-DD');
              link.download = time + '测风塔报告.doc';
              link.click();
              this.aswitch.close();
            })
            .catch(() => {
              this.aswitch.close();
            });
        }
      }
    },
    closeModal() {
      this.dialogVisible = false;
      this.$emit('close');
    },
    handleClose() {
      this.myVisible = false;
      this.$emit('close');
    }
  }
};
</script>

<style lang="less" scoped>
.search_input {
  margin-bottom: 15px;
}
</style>
